import React from 'react';
import { connect } from 'react-redux';
import AppBaseComponent from '../../../components/AppBaseComponent';
import HttpAPICall from '../../../services/HttpAPICall';
import { IAM_API_BASE_URL_2 } from '../../../services/TapApiUrls';
import { Modal } from 'bootstrap';
import Ax from "../../../components/hoc/Ax";
import Loader from "../../../components/ui/Loader/Loader";
import TapSelect from '../../../components/ui/TapSelect';
import moment from 'moment';
import DatePicker from "react-datepicker";
import TapIcon from '../../../services/TapIcon';
import { toast } from 'react-toastify';
import uuid from 'react-uuid';
import DateService from '../../../services/DateService';

class SiteTransitionDetail extends AppBaseComponent {

    constructor(props) {
        super(props);
        this.siteTransitionModalId = uuid();
        this.state = {
            siteTransitionDetail: null,
        }
    }
    componentDidMount = () => {
        this.siteTransitionModal = new Modal(document.getElementById(this.siteTransitionModalId), { keyboard: false, backdrop: false });
    }

    siteTransitionModalInit = (data) => {
        
        this.setState({
            siteTransitionDetail: data || ""
        })
        this.siteTransitionModal.show()
    }


    siteTransitionModalJsx = () => {
        const detail = this.state.siteTransitionDetail
        return (
            <div className="modal fade" id={this.siteTransitionModalId} tabIndex="-1">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="searchAssetModalLabel">Asset Site Transition Detail</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            {detail &&
                                (<>
                                    <div className='row align-items-center my-3'>
                                        <div className='col-4'>Previous Site</div>
                                        <div className='col-6 fw-bold'>{detail && detail.prev_site_data &&  detail.prev_site_data.site_name}</div>
                                    </div>
                                    <div className='row align-items-center my-3'>
                                        <div className='col-4'>New Site</div>
                                        <div className='col-6 fw-bold'>{detail && detail.site_data &&  detail.site_data.site_name}</div>
                                    </div>
                                    <div className='row align-items-center my-3'>
                                        <div className='col-4'> From</div>
                                        <div className='col-6 fw-bold'>{detail?.from_dispaly || "-"}</div>
                                    </div>
                                    <div className='row align-items-center my-3'>
                                        <div className='col-4'>To</div>
                                        <div className='col-6 fw-bold'>{detail?.till_dispaly || "-"}</div>
                                    </div> 
                                    <div className='row align-items-center my-3'>
                                        <div className='col-4'>Numberof days</div>
                                        <div className='col-6 fw-bold'>{detail?.diff_days ? detail?.diff_days : '0'}</div>
                                    </div>
                                    <div className='row align-items-center my-3'>
                                        <div className='col-4'>Prev Roster</div>
                                        <div className='col-6 fw-bold'>{detail && detail.prev_roster_data &&  detail.prev_roster_data.roster_name}</div>
                                    </div>
                                    <div className='row align-items-center my-3'>
                                        <div className='col-4'>New Roster</div>
                                        <div className='col-6 fw-bold'>{detail && detail.roster_data &&  detail.roster_data.roster_name}</div>
                                    </div>
                                    <div className='row align-items-center my-3'>
                                        <div className='col-4'>Notes</div>
                                        <div className='col-6 fw-bold'>{detail?.notes || "-"}</div>
                                    </div>
                                    <div className='row align-items-center my-3'>
                                        <div className='col-4'>Created On</div>
                                        <div className='col-6 fw-bold'>{detail.created_at ? DateService.dateTimeFormat(detail.created_at) : "-"}</div>
                                    </div>
                                </>)
                            }
                        </div>
                        <div className="modal-footer row">
                            <div className="col text-end">
                                <button type="button" className="btn btn-secondary mx-2" data-bs-dismiss="modal">Close</button>

                            </div>
                        </div>

                    </div>
                </div>
            </div>
        );
    }

    render() {
        return (<Ax>
            {this.siteTransitionModalJsx()}
        </Ax>);
    }

}

const mapStateToProps = state => {
    return {
        access_token: state.auth.access_token,
        iam_user_sites: state.app && state.app.user_sites ? state.app.user_sites : [],
        permissions: state.app && state.app.acl_info ? state.app.acl_info : null,
    };
};


export default connect(mapStateToProps, null, null, { forwardRef: true })(SiteTransitionDetail);

